import moment from 'moment'

const dateNullValue = moment('0001-01-01', 'YYYY-MM-DD')

export function isDateNullValue(input: moment.Moment) {
  return input.isSame(dateNullValue, 'day')
}
